import { render } from "./PromotionsCarousel.vue?vue&type=template&id=1291ad6c&scoped=true"
import script from "./PromotionsCarousel.vue?vue&type=script&lang=js"
export * from "./PromotionsCarousel.vue?vue&type=script&lang=js"

import "./PromotionsCarousel.vue?vue&type=style&index=0&id=1291ad6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1291ad6c"]])

export default __exports__